import { useMutation } from "@tanstack/react-query";
import { GET } from "@/services/api-request";
import { toast } from "sonner";

export const useSendEmailVerification = (setShow: any) => {
  const { mutate, isPending, error } = useMutation({
    mutationFn: async (email: string) => {
      return GET(`/auth/send-email-verification?email=${email}`, "");
    },
    onSuccess: (data: any) => {
      toast.success(data.message || "Verification link sent successfully.");
      setShow(false);
    },
    onError: (e: any) => {
      toast.error(e?.response?.data?.message || "Error sending email.");
    },
  });

  return {
    sendVerificationEmail: mutate,
    sending: isPending,
    error,
  };
};
